/** 根据 User-Agent 自动检测设备名称（OS + 浏览器） */
export function getDefaultDeviceName(): string {
  const ua = navigator.userAgent
  let os = '未知设备'
  if (/iPhone|iPad|iPod/.test(ua))
    os = /iPad/.test(ua) ? 'iPad' : 'iPhone'
  else if (/Android/.test(ua))
    os = '安卓'
  else if (/Mac/.test(ua))
    os = 'Mac'
  else if (/Windows/.test(ua))
    os = 'Windows'
  else if (/Linux/.test(ua))
    os = 'Linux'

  let browser = ''
  if (/Edg\//.test(ua))
    browser = 'Edge'
  else if (/Chrome\//.test(ua))
    browser = 'Chrome'
  else if (/Safari\//.test(ua) && !/Chrome/.test(ua))
    browser = 'Safari'
  else if (/Firefox\//.test(ua))
    browser = 'Firefox'

  return browser ? `${os} · ${browser}` : os
}
